/*global googleFonts*/

import { Controller } from "@hotwired/stimulus";
import Customization from "./customization/index";
import {
  onCustomizationChange,
  onCustomizationFinish,
} from "./customization/event";
import CustomizationRequest from "./customization/request";
import { loadFonts } from "./customization/lib";

// Connects to data-controller="site-builder--message"
export default class extends Controller {
  static targets = ["loader", "content"];

  initialize() {
    this.isPersisted = !!document.body.dataset.siteBuilderSite;
    onCustomizationChange(async (changes) => {
      await Customization.apply(changes);
      CustomizationRequest.notifyUpdateFinished(changes);
    });

    onCustomizationFinish(() => {
      Customization.applyLocalChanges();
      CustomizationRequest.notifyUpdateFinished();
      window.scrollTo(0, 0);
    });

    this.#setup();
  }

  #setup() {
    /*
        When running site builder in persistence mode, defaults are fetched from the backend.
        Therefore, during the first load all the required customizations are already present.

        When not running in persistence mode, the customizations are present in localstorage. We need
        to send customizations in the request to apply these customizations.
     */
    if (this.isPersisted) {
      Customization.persistedSetup().then(() => {
        this.#showPreview();
      });
    } else {
      loadFonts();
      Customization.setup().then(() => {
        this.#showPreview();
      });
    }
  }

  #showPreview() {
    this.contentTarget.classList.add("show");
    this.loaderTarget.classList.add("hide");
  }
}
